import { useEffect } from 'react';
import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { Toaster } from 'react-hot-toast';
import { initializeI18n } from '../../i18n';
import { RTL } from '../../components/rtl';
import { useSettings } from '../../contexts/settings-context';
import { useAuth } from '../../hooks/use-auth';
import routes from '../../routes';
import { createCustomTheme } from '../../theme';

export const App: FC = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const { isInitialized } = useAuth();

  useEffect(() => {
    initializeI18n(settings.language);
  }, [settings]);

  const theme = createCustomTheme({
    direction: settings.direction,
    theme: 'light',
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <RTL direction={settings.direction}>
          <CssBaseline />
          {isInitialized && content}
        </RTL>
      </ThemeProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            maxWidth: '500px',
          },
        }}
      />
    </>
  );
};
